var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('footer',[_c('div',{staticClass:"container"},[_c('p',[_vm._v("Made with 🖤"),_c('br'),_vm._v("by "),_c('a',{attrs:{"href":"http://www.dennisschmidt.net","target":"_blank"}},[_vm._v("Dennis Schmidt")]),_c('br'),_vm._v("in Hamburg, Germany")])])])
}]

export { render, staticRenderFns }